import { NoticeHistory } from '@/modules/pipelines/model/pipeline-alerts/pipeline-alert';
import dayjs from 'dayjs';
import EventTypeBadge from '@/modules/pipelines/components/scroller/badges/event-type-badge';
import EventStatusBadge from '@/modules/pipelines/components/scroller/badges/event-status-badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { ProgressBar } from 'react-bootstrap';
import styles from '@/modules/pipelines/components/scroller/preprod-stripes.module.scss';
import '@/modules/pipelines/components/scroller/pipeline-scroller.scss';

export default function PipelineScrollerEntry({
  notification,
  onShowInfo,
  onShowEvent,
}: {
  notification: NoticeHistory;
  onShowInfo: () => void;
  onShowEvent?: () => void;
}) {
  const { postedAt, operator, planningStatus, eventStatus, eventType } = notification;
  const { name: operatorName } = operator || {};

  const isToday = dayjs(postedAt).isSame(dayjs(), 'day');

  const handleItemClick = () => {
    notification.size > 1 && onShowEvent ? onShowEvent() : onShowInfo();
  };

  return (
    <tr role="button" className={isToday ? '' : 'table-old'} onClick={() => handleItemClick()}>
      <td className="text-center">
        {!isToday && (
          <div className="fw-bold text-warning-emphasis">{dayjs(postedAt).format('MMM D')}</div>
        )}
        <div className="font-monospace">{dayjs(postedAt).format('hh:mmA')}</div>
        <div className={'d-container-block d-container-sm-none'}>
          <span className="d-flex flex-wrap gap-1 justify-content-center">
            {[eventStatus, planningStatus].map(i => (
              <EventStatusBadge input={i} />
            ))}
          </span>
        </div>
      </td>

      <td className="text-center">
        <div className={'d-container-none d-container-sm-block'}>
          <span className="d-flex flex-wrap gap-1 justify-content-center">
            {[eventStatus, planningStatus].map(i => (
              <EventStatusBadge input={i} />
            ))}
          </span>
        </div>
      </td>
      <td className={'text-center'}>
        <div className="d-flex flex-column align-items-center">
          <span className="fw-bold">{operatorName}</span>
          {notification.operator.devState !== 'release' && (
            <ProgressBar
              striped
              now={100}
              label={`${notification.operator.devState.toUpperCase()}`}
              className={`${styles['preprod-stripes']} ${styles[notification.operator.devState]} rounded-3`}
            />
          )}
        </div>
      </td>
      <td className={'text-center '}>
        <div className={' mb-1 d-container-none d-container-sm-block'}>
          <EventTypeBadge input={notification.eventTypeClassification?.name} />
        </div>
      </td>

      <td style={{ width: '50%', maxWidth: 0 }} className="">
        <div className="d-flex align-items-center justify-content-between ">
          <div style={{ minWidth: 0 }} className={''}>
            <div className={' mb-1 d-container-block d-container-sm-none'}>
              <EventTypeBadge input={notification.eventTypeClassification?.name} />
              {notification.relatedEntities && notification.relatedEntities.length > 0 && (
                <FontAwesomeIcon icon={faLink} />
              )}{' '}
              {/* careful with this one here */}
            </div>

            <div className="d-flex gap-1 align-items-center">
              {notification.isCritical && <FontAwesomeIcon icon={faStopwatch} />}
              <span className="text-muted">{eventType}</span>
            </div>
          </div>

          {notification.size > 1 && (
            <div
              className="bg-secondary rounded-5 flex-shrink-0 font-monospace text-center ms-2"
              style={{ height: '17px', width: '17px' }}
            >
              {notification.size}
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
